import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { NosotrosComponent } from './components/nosotros/nosotros.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { ExitosoComponent } from './components/contacto/exitoso.component';
import { ListarComponent } from './components/contacto/listar.component';
import { ServiciosComponent } from './components/servicios/servicios.component';

const APP_ROUTES: Routes = [
    { path: 'home', component: HomeComponent },
    { path: 'nosotros', component: NosotrosComponent },
    { path: 'servicios', component: ServiciosComponent },
    { path: 'contacto', component: ContactoComponent },
    { path: 'listar', component: ListarComponent },
    { path: 'exitoso/:id', component: ExitosoComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'home'},
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { useHash: true });



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/app.route.ts